require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.function.bind");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

!function (e, a) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = a(require("react"), require("prop-types"), require("aplayer"));else if ("function" === typeof define && define.amd) define(["react", "prop-types", "aplayer"], a);else {
    var r = "object" === typeof exports ? a(require("react"), require("prop-types"), require("aplayer")) : a(e.react, e["prop-types"], e.aplayer);

    for (var t in r) {
      ("object" === typeof exports ? exports : e)[t] = r[t];
    }
  }
}(this, function (e, a, r) {
  return function (e) {
    function a(t) {
      if (r[t]) return r[t].exports;
      var o = r[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, a), o.l = !0, o.exports;
    }

    var r = {};
    return a.m = e, a.c = r, a.d = function (e, r, t) {
      a.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: t
      });
    }, a.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return a.d(r, "a", r), r;
    }, a.o = function (e, a) {
      return Object.prototype.hasOwnProperty.call(e, a);
    }, a.p = "", a(a.s = 0);
  }([function (e, a, r) {
    "use strict";

    function t(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function o(e, a) {
      var r = {};

      for (var t in e) {
        a.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
      }

      return r;
    }

    function l(e, a) {
      if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, a) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !a || "object" !== typeof a && "function" !== typeof a ? e : a;
    }

    function n(e, a) {
      if ("function" !== typeof a && null !== a) throw new TypeError("Super expression must either be null or a function, not " + typeof a);
      e.prototype = Object.create(a && a.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), a && (Object.setPrototypeOf ? Object.setPrototypeOf(e, a) : e.__proto__ = a);
    }

    Object.defineProperty(a, "__esModule", {
      value: !0
    });

    var p = Object.assign || function (e) {
      for (var a = 1; a < arguments.length; a++) {
        var r = arguments[a];

        for (var t in r) {
          Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
      }

      return e;
    },
        s = function () {
      function e(e, a) {
        for (var r = 0; r < a.length; r++) {
          var t = a[r];
          t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (a, r, t) {
        return r && e(a.prototype, r), t && e(a, t), a;
      };
    }(),
        y = r(1),
        f = t(y),
        c = r(2),
        d = t(c),
        u = r(3),
        h = t(u);

    r(4);

    var b = r(9),
        m = t(b),
        x = function x(e) {
      return e[0].toUpperCase() + e.slice(1);
    },
        g = m["default"].reduce(function (e, a) {
      return e["on" + x(a)] = d["default"].func, e;
    }, {}),
        w = d["default"].shape({
      name: d["default"].string,
      artist: d["default"].string,
      url: d["default"].string,
      cover: d["default"].string,
      lrc: d["default"].string,
      theme: d["default"].string,
      type: d["default"].string
    }),
        v = function (e) {
      function a() {
        return l(this, a), i(this, (a.__proto__ || Object.getPrototypeOf(a)).apply(this, arguments));
      }

      return n(a, e), s(a, [{
        key: "componentDidMount",
        value: function value() {
          var e = this,
              a = this.props,
              r = a.onInit,
              t = o(a, ["onInit"]),
              l = new h["default"](p({}, t, {
            container: this.container
          }));
          m["default"].forEach(function (a) {
            var r = "on" + x(a),
                t = e.props[r];
            t && l.on(a, t);
          }), this.control = l, r(l);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return f["default"].createElement("div", {
            ref: function ref(a) {
              return e.container = a;
            }
          });
        }
      }]), a;
    }(f["default"].Component);

    v.propTypes = p({
      onInit: d["default"].func,
      fixed: d["default"].bool,
      mini: d["default"].bool,
      autoplay: d["default"].bool,
      theme: d["default"].string,
      loop: d["default"].oneOf(["all", "one", "none"]),
      order: d["default"].oneOf(["list", "random"]),
      preload: d["default"].oneOf(["auto", "metadata", "none"]),
      volume: d["default"].number,
      audio: d["default"].oneOfType([w, d["default"].arrayOf(w)]),
      customAudioType: d["default"].object,
      mutex: d["default"].bool,
      lrcType: d["default"].number,
      listFolded: d["default"].bool,
      listMaxHeight: d["default"].string,
      storageName: d["default"].string
    }, g), v.defaultProps = {
      onInit: function onInit() {},
      fixed: !1,
      mini: !1,
      autoplay: !1,
      theme: "#b7daff",
      loop: "all",
      order: "list",
      preload: "auto",
      volume: .7,
      mutex: !0,
      lrcType: 0,
      listFolded: !1,
      storageName: "react-aplayer-setting"
    }, a["default"] = v;
  }, function (a, r) {
    a.exports = e;
  }, function (e, r) {
    e.exports = a;
  }, function (e, a) {
    e.exports = r;
  }, function (e, a, r) {
    var t = r(5);
    "string" === typeof t && (t = [[e.i, t, ""]]);
    var o = {
      hmr: !0
    };
    o.transform = void 0;
    r(7)(t, o);
    t.locals && (e.exports = t.locals);
  }, function (e, a, r) {
    a = e.exports = r(6)(void 0), a.push([e.i, '.aplayer{background:#fff;font-family:Arial,Helvetica,sans-serif;margin:5px;box-shadow:0 2px 2px 0 rgba(0,0,0,.07),0 1px 5px 0 rgba(0,0,0,.1);border-radius:2px;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:normal;position:relative}.aplayer *{box-sizing:content-box}.aplayer svg{width:100%;height:100%}.aplayer svg circle,.aplayer svg path{fill:#fff}.aplayer.aplayer-withlist .aplayer-info{border-bottom:1px solid #e9e9e9}.aplayer.aplayer-withlist .aplayer-list{display:block}.aplayer.aplayer-withlist .aplayer-icon-order,.aplayer.aplayer-withlist .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon.aplayer-icon-menu{display:inline}.aplayer.aplayer-withlrc .aplayer-pic{height:90px;width:90px}.aplayer.aplayer-withlrc .aplayer-info{margin-left:90px;height:90px;padding:10px 7px 0}.aplayer.aplayer-withlrc .aplayer-lrc{display:block}.aplayer.aplayer-narrow{width:66px}.aplayer.aplayer-narrow .aplayer-info,.aplayer.aplayer-narrow .aplayer-list{display:none}.aplayer.aplayer-narrow .aplayer-body,.aplayer.aplayer-narrow .aplayer-pic{height:66px;width:66px}.aplayer.aplayer-fixed{position:fixed;bottom:0;left:0;right:0;margin:0;z-index:99;overflow:visible;max-width:400px;box-shadow:none}.aplayer.aplayer-fixed .aplayer-list{margin-bottom:65px;border:1px solid #eee;border-bottom:none}.aplayer.aplayer-fixed .aplayer-body{position:fixed;bottom:0;left:0;right:0;margin:0;z-index:99;background:#fff;padding-right:18px;transition:all .3s ease;max-width:400px}.aplayer.aplayer-fixed .aplayer-lrc{display:block;position:fixed;bottom:10px;left:0;right:0;margin:0;z-index:98;pointer-events:none;text-shadow:0 0 1px #fff,0 0 10px #fff}.aplayer.aplayer-fixed .aplayer-lrc:after,.aplayer.aplayer-fixed .aplayer-lrc:before{display:none}.aplayer.aplayer-fixed .aplayer-info{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:0 0;transform-origin:0 0;transition:all .3s ease;border-bottom:none;border-top:1px solid #e9e9e9}.aplayer.aplayer-fixed .aplayer-info .aplayer-music{width:calc(100% - 105px)}.aplayer.aplayer-fixed .aplayer-miniswitcher{display:block}.aplayer.aplayer-fixed.aplayer-narrow .aplayer-info{display:block;-webkit-transform:scaleX(0);transform:scaleX(0)}.aplayer.aplayer-fixed.aplayer-narrow .aplayer-body{width:66px!important}.aplayer.aplayer-fixed.aplayer-narrow .aplayer-miniswitcher .aplayer-icon{-webkit-transform:rotateY(0);transform:rotateY(0)}.aplayer.aplayer-fixed .aplayer-icon-back,.aplayer.aplayer-fixed .aplayer-icon-forward,.aplayer.aplayer-fixed .aplayer-icon-lrc,.aplayer.aplayer-fixed .aplayer-icon-play{display:inline-block}.aplayer.aplayer-fixed .aplayer-icon-back,.aplayer.aplayer-fixed .aplayer-icon-forward,.aplayer.aplayer-fixed .aplayer-icon-menu,.aplayer.aplayer-fixed .aplayer-icon-play{position:absolute;bottom:27px;width:20px;height:20px}.aplayer.aplayer-fixed .aplayer-icon-back{right:75px}.aplayer.aplayer-fixed .aplayer-icon-play{right:50px}.aplayer.aplayer-fixed .aplayer-icon-forward{right:25px}.aplayer.aplayer-fixed .aplayer-icon-menu{right:0}.aplayer.aplayer-arrow .aplayer-icon-loop,.aplayer.aplayer-arrow .aplayer-icon-order,.aplayer.aplayer-mobile .aplayer-icon-volume-down{display:none}.aplayer.aplayer-loading .aplayer-info .aplayer-controller .aplayer-loading-icon{display:block}.aplayer.aplayer-loading .aplayer-info .aplayer-controller .aplayer-bar-wrap .aplayer-bar .aplayer-played .aplayer-thumb{-webkit-transform:scale(1);transform:scale(1)}.aplayer .aplayer-body{position:relative}.aplayer .aplayer-icon{width:15px;height:15px;border:none;background-color:transparent;outline:none;cursor:pointer;opacity:.8;vertical-align:middle;padding:0;font-size:12px;margin:0;display:inline-block}.aplayer .aplayer-icon path{transition:all .2s ease-in-out}.aplayer .aplayer-icon-back,.aplayer .aplayer-icon-forward,.aplayer .aplayer-icon-lrc,.aplayer .aplayer-icon-order,.aplayer .aplayer-icon-play{display:none}.aplayer .aplayer-icon-lrc-inactivity svg{opacity:.4}.aplayer .aplayer-icon-forward{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.aplayer .aplayer-lrc-content{display:none}.aplayer .aplayer-pic{position:relative;float:left;height:66px;width:66px;background-size:cover;background-position:50%;transition:all .3s ease;cursor:pointer}.aplayer .aplayer-pic:hover .aplayer-button{opacity:1}.aplayer .aplayer-pic .aplayer-button{position:absolute;border-radius:50%;opacity:.8;text-shadow:0 1px 1px rgba(0,0,0,.2);box-shadow:0 1px 1px rgba(0,0,0,.2);background:rgba(0,0,0,.2);transition:all .1s ease}.aplayer .aplayer-pic .aplayer-button path{fill:#fff}.aplayer .aplayer-pic .aplayer-hide{display:none}.aplayer .aplayer-pic .aplayer-play{width:26px;height:26px;border:2px solid #fff;bottom:50%;right:50%;margin:0 -15px -15px 0}.aplayer .aplayer-pic .aplayer-play svg{position:absolute;top:3px;left:4px;height:20px;width:20px}.aplayer .aplayer-pic .aplayer-pause{width:16px;height:16px;border:2px solid #fff;bottom:4px;right:4px}.aplayer .aplayer-pic .aplayer-pause svg{position:absolute;top:2px;left:2px;height:12px;width:12px}.aplayer .aplayer-info{margin-left:66px;padding:14px 7px 0 10px;height:66px;box-sizing:border-box}.aplayer .aplayer-info .aplayer-music{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin:0 0 13px 5px;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:default;padding-bottom:2px}.aplayer .aplayer-info .aplayer-music .aplayer-title{font-size:14px}.aplayer .aplayer-info .aplayer-music .aplayer-author{font-size:12px;color:#666}.aplayer .aplayer-info .aplayer-controller{position:relative;display:flex}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap{margin:0 0 0 5px;padding:4px 0;cursor:pointer!important;flex:1}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap:hover .aplayer-bar .aplayer-played .aplayer-thumb{-webkit-transform:scale(1);transform:scale(1)}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap .aplayer-bar{position:relative;height:2px;width:100%;background:#cdcdcd}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap .aplayer-bar .aplayer-loaded{position:absolute;left:0;top:0;bottom:0;background:#aaa;height:2px;transition:all .5s ease}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap .aplayer-bar .aplayer-played{position:absolute;left:0;top:0;bottom:0;height:2px}.aplayer .aplayer-info .aplayer-controller .aplayer-bar-wrap .aplayer-bar .aplayer-played .aplayer-thumb{position:absolute;top:0;right:5px;margin-top:-4px;margin-right:-10px;height:10px;width:10px;border-radius:50%;cursor:pointer;transition:all .3s ease-in-out;-webkit-transform:scale(0);transform:scale(0)}.aplayer .aplayer-info .aplayer-controller .aplayer-time{position:relative;right:0;bottom:4px;height:17px;color:#999;font-size:11px;padding-left:7px}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-time-inner{vertical-align:middle}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon{cursor:pointer;transition:all .2s ease}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon path{fill:#666}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon.aplayer-icon-loop{margin-right:2px}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon:hover path{fill:#000}.aplayer .aplayer-info .aplayer-controller .aplayer-time .aplayer-icon.aplayer-icon-menu,.aplayer .aplayer-info .aplayer-controller .aplayer-time.aplayer-time-narrow .aplayer-icon-menu,.aplayer .aplayer-info .aplayer-controller .aplayer-time.aplayer-time-narrow .aplayer-icon-mode{display:none}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap{position:relative;display:inline-block;margin-left:3px;cursor:pointer!important}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap:hover .aplayer-volume-bar-wrap{height:40px}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap .aplayer-volume-bar-wrap{position:absolute;bottom:15px;right:-3px;width:25px;height:0;z-index:99;overflow:hidden;transition:all .2s ease-in-out}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap .aplayer-volume-bar-wrap.aplayer-volume-bar-wrap-active{height:40px}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap .aplayer-volume-bar-wrap .aplayer-volume-bar{position:absolute;bottom:0;right:10px;width:5px;height:35px;background:#aaa;border-radius:2.5px;overflow:hidden}.aplayer .aplayer-info .aplayer-controller .aplayer-volume-wrap .aplayer-volume-bar-wrap .aplayer-volume-bar .aplayer-volume{position:absolute;bottom:0;right:0;width:5px;transition:all .1s ease}.aplayer .aplayer-info .aplayer-controller .aplayer-loading-icon{display:none}.aplayer .aplayer-info .aplayer-controller .aplayer-loading-icon svg{position:absolute;-webkit-animation:rotate 1s linear infinite;animation:rotate 1s linear infinite}.aplayer .aplayer-lrc{display:none;position:relative;height:30px;text-align:center;overflow:hidden;margin:-10px 0 7px}.aplayer .aplayer-lrc:before{top:0;height:10%;background:linear-gradient(180deg,#fff 0,hsla(0,0%,100%,0));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#00ffffff",GradientType=0)}.aplayer .aplayer-lrc:after,.aplayer .aplayer-lrc:before{position:absolute;z-index:1;display:block;overflow:hidden;width:100%;content:" "}.aplayer .aplayer-lrc:after{bottom:0;height:33%;background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,.8));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff",endColorstr="#ccffffff",GradientType=0)}.aplayer .aplayer-lrc p{font-size:12px;color:#666;line-height:16px!important;height:16px!important;padding:0!important;margin:0!important;transition:all .5s ease-out;opacity:.4;overflow:hidden}.aplayer .aplayer-lrc p.aplayer-lrc-current{opacity:1;overflow:visible;height:auto!important;min-height:16px}.aplayer .aplayer-lrc.aplayer-lrc-hide{display:none}.aplayer .aplayer-lrc .aplayer-lrc-contents{width:100%;transition:all .5s ease-out;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:default}.aplayer .aplayer-list{overflow:auto;transition:all .5s ease;will-change:height;display:none;overflow:hidden}.aplayer .aplayer-list.aplayer-list-hide{max-height:0!important}.aplayer .aplayer-list ol{list-style-type:none;margin:0;padding:0;overflow-y:auto}.aplayer .aplayer-list ol::-webkit-scrollbar{width:5px}.aplayer .aplayer-list ol::-webkit-scrollbar-thumb{border-radius:3px;background-color:#eee}.aplayer .aplayer-list ol::-webkit-scrollbar-thumb:hover{background-color:#ccc}.aplayer .aplayer-list ol li{position:relative;height:32px;line-height:32px;padding:0 15px;font-size:12px;border-top:1px solid #e9e9e9;cursor:pointer;transition:all .2s ease;overflow:hidden;margin:0}.aplayer .aplayer-list ol li:first-child{border-top:none}.aplayer .aplayer-list ol li:hover{background:#efefef}.aplayer .aplayer-list ol li.aplayer-list-light{background:#e9e9e9}.aplayer .aplayer-list ol li.aplayer-list-light .aplayer-list-cur{display:inline-block}.aplayer .aplayer-list ol li .aplayer-list-cur{display:none;width:3px;height:22px;position:absolute;left:0;top:5px;cursor:pointer}.aplayer .aplayer-list ol li .aplayer-list-index{color:#666;margin-right:12px;cursor:pointer}.aplayer .aplayer-list ol li .aplayer-list-author{color:#666;float:right;cursor:pointer}.aplayer .aplayer-notice{opacity:0;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);font-size:12px;border-radius:4px;padding:5px 10px;transition:all .3s ease-in-out;overflow:hidden;color:#fff;pointer-events:none;background-color:#f4f4f5;color:#909399}.aplayer .aplayer-miniswitcher{display:none;position:absolute;top:0;right:0;bottom:0;height:100%;background:#e6e6e6;width:18px;border-radius:0 2px 2px 0}.aplayer .aplayer-miniswitcher .aplayer-icon{height:100%;width:100%;-webkit-transform:rotateY(180deg);transform:rotateY(180deg);transition:all .3s ease}.aplayer .aplayer-miniswitcher .aplayer-icon path{fill:#666}.aplayer .aplayer-miniswitcher .aplayer-icon:hover path{fill:#000}@-webkit-keyframes aplayer-roll{0%{left:0}to{left:-100%}}@keyframes aplayer-roll{0%{left:0}to{left:-100%}}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}', ""]);
  }, function (e, a) {
    function r(e, a) {
      var r = e[1] || "",
          o = e[3];
      if (!o) return r;

      if (a && "function" === typeof btoa) {
        var l = t(o);
        return [r].concat(o.sources.map(function (e) {
          return "/*# sourceURL=" + o.sourceRoot + e + " */";
        })).concat([l]).join("\n");
      }

      return [r].join("\n");
    }

    function t(e) {
      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
    }

    e.exports = function (e) {
      var a = [];
      return a.toString = function () {
        return this.map(function (a) {
          var t = r(a, e);
          return a[2] ? "@media " + a[2] + "{" + t + "}" : t;
        }).join("");
      }, a.i = function (e, r) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var t = {}, o = 0; o < this.length; o++) {
          var l = this[o][0];
          "number" === typeof l && (t[l] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var i = e[o];
          "number" === typeof i[0] && t[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), a.push(i));
        }
      }, a;
    };
  }, function (e, a, r) {
    function t(e, a) {
      for (var r = 0; r < e.length; r++) {
        var t = e[r],
            o = u[t.id];

        if (o) {
          o.refs++;

          for (var l = 0; l < o.parts.length; l++) {
            o.parts[l](t.parts[l]);
          }

          for (; l < t.parts.length; l++) {
            o.parts.push(y(t.parts[l], a));
          }
        } else {
          for (var i = [], l = 0; l < t.parts.length; l++) {
            i.push(y(t.parts[l], a));
          }

          u[t.id] = {
            id: t.id,
            refs: 1,
            parts: i
          };
        }
      }
    }

    function o(e, a) {
      for (var r = [], t = {}, o = 0; o < e.length; o++) {
        var l = e[o],
            i = a.base ? l[0] + a.base : l[0],
            n = l[1],
            p = l[2],
            s = l[3],
            y = {
          css: n,
          media: p,
          sourceMap: s
        };
        t[i] ? t[i].parts.push(y) : r.push(t[i] = {
          id: i,
          parts: [y]
        });
      }

      return r;
    }

    function l(e, a) {
      var r = b(e.insertInto);
      if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var t = g[g.length - 1];
      if ("top" === e.insertAt) t ? t.nextSibling ? r.insertBefore(a, t.nextSibling) : r.appendChild(a) : r.insertBefore(a, r.firstChild), g.push(a);else if ("bottom" === e.insertAt) r.appendChild(a);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = b(e.insertInto + " " + e.insertAt.before);
        r.insertBefore(a, o);
      }
    }

    function i(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var a = g.indexOf(e);
      a >= 0 && g.splice(a, 1);
    }

    function n(e) {
      var a = document.createElement("style");
      return e.attrs.type = "text/css", s(a, e.attrs), l(e, a), a;
    }

    function p(e) {
      var a = document.createElement("link");
      return e.attrs.type = "text/css", e.attrs.rel = "stylesheet", s(a, e.attrs), l(e, a), a;
    }

    function s(e, a) {
      Object.keys(a).forEach(function (r) {
        e.setAttribute(r, a[r]);
      });
    }

    function y(e, a) {
      var r, t, o, l;

      if (a.transform && e.css) {
        if (!(l = a.transform(e.css))) return function () {};
        e.css = l;
      }

      if (a.singleton) {
        var s = x++;
        r = m || (m = n(a)), t = f.bind(null, r, s, !1), o = f.bind(null, r, s, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (r = p(a), t = d.bind(null, r, a), o = function o() {
        i(r), r.href && URL.revokeObjectURL(r.href);
      }) : (r = n(a), t = c.bind(null, r), o = function o() {
        i(r);
      });

      return t(e), function (a) {
        if (a) {
          if (a.css === e.css && a.media === e.media && a.sourceMap === e.sourceMap) return;
          t(e = a);
        } else o();
      };
    }

    function f(e, a, r, t) {
      var o = r ? "" : t.css;
      if (e.styleSheet) e.styleSheet.cssText = v(a, o);else {
        var l = document.createTextNode(o),
            i = e.childNodes;
        i[a] && e.removeChild(i[a]), i.length ? e.insertBefore(l, i[a]) : e.appendChild(l);
      }
    }

    function c(e, a) {
      var r = a.css,
          t = a.media;
      if (t && e.setAttribute("media", t), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }

    function d(e, a, r) {
      var t = r.css,
          o = r.sourceMap,
          l = void 0 === a.convertToAbsoluteUrls && o;
      (a.convertToAbsoluteUrls || l) && (t = w(t)), o && (t += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([t], {
        type: "text/css"
      }),
          n = e.href;
      e.href = URL.createObjectURL(i), n && URL.revokeObjectURL(n);
    }

    var u = {},
        h = function (e) {
      var a;
      return function () {
        return "undefined" === typeof a && (a = e.apply(this, arguments)), a;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        b = function (e) {
      var a = {};
      return function (r) {
        if ("undefined" === typeof a[r]) {
          var t = e.call(this, r);
          if (t instanceof window.HTMLIFrameElement) try {
            t = t.contentDocument.head;
          } catch (e) {
            t = null;
          }
          a[r] = t;
        }

        return a[r];
      };
    }(function (e) {
      return document.querySelector(e);
    }),
        m = null,
        x = 0,
        g = [],
        w = r(8);

    e.exports = function (e, a) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      a = a || {}, a.attrs = "object" === typeof a.attrs ? a.attrs : {}, a.singleton || (a.singleton = h()), a.insertInto || (a.insertInto = "head"), a.insertAt || (a.insertAt = "bottom");
      var r = o(e, a);
      return t(r, a), function (e) {
        for (var l = [], i = 0; i < r.length; i++) {
          var n = r[i],
              p = u[n.id];
          p.refs--, l.push(p);
        }

        if (e) {
          t(o(e, a), a);
        }

        for (var i = 0; i < l.length; i++) {
          var p = l[i];

          if (0 === p.refs) {
            for (var s = 0; s < p.parts.length; s++) {
              p.parts[s]();
            }

            delete u[p.id];
          }
        }
      };
    };

    var v = function () {
      var e = [];
      return function (a, r) {
        return e[a] = r, e.filter(Boolean).join("\n");
      };
    }();
  }, function (e, a) {
    e.exports = function (e) {
      var a = "undefined" !== typeof window && window.location;
      if (!a) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var r = a.protocol + "//" + a.host,
          t = r + a.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, a) {
        var o = a.trim().replace(/^"(.*)"$/, function (e, a) {
          return a;
        }).replace(/^'(.*)'$/, function (e, a) {
          return a;
        });
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o)) return e;
        var l;
        return l = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? r + o : t + o.replace(/^\.\//, ""), "url(" + JSON.stringify(l) + ")";
      });
    };
  }, function (e, a, r) {
    "use strict";

    Object.defineProperty(a, "__esModule", {
      value: !0
    });
    var t = a.audioEvents = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "mozaudioavailable", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
        o = a.playerEvents = ["listshow", "listhide", "listadd", "listremove", "listswitch", "listclear", "noticeshow", "noticehide", "destroy", "lrcshow", "lrchide"],
        l = [].concat(t, o);
    a["default"] = l;
  }]);
});